import * as React from 'react';
import { styled } from '../../theme/theme';
import { useGlobalStore } from '../../store/useGlobalStore';
import { ChatViewMessageRow } from './ChatViewMessageRow';

type Props = {
  //
};

export const MessageList = ({}: Props) => {
  const messages = useGlobalStore((store) => store.conversation.conversation.messages);
  return (
    <>
      {messages.map((message) => (
        <ChatViewMessageRow
          key={message.id}
          message={message}
        />
      ))}
    </>
  );
};

export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
